var _path, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2853 2.421C7.58073 1.83361 8.41927 1.83361 8.7147 2.421L10.1298 5.23465C10.2474 5.46843 10.4719 5.62993 10.7309 5.66709L13.8718 6.11764C14.5324 6.2124 14.7934 7.02669 14.311 7.48782L12.0588 9.64067C11.8658 9.82513 11.7776 10.0937 11.8235 10.3567L12.3575 13.4121C12.4714 14.0636 11.7903 14.564 11.2025 14.2607L8.36691 12.7972C8.13673 12.6784 7.86327 12.6783 7.63309 12.7972L4.79747 14.2607C4.2097 14.564 3.52864 14.0636 3.64251 13.4121L4.17646 10.3567C4.22241 10.0937 4.13417 9.82513 3.94119 9.64067L1.68904 7.48782C1.20664 7.02669 1.46765 6.2124 2.12824 6.11764L5.26907 5.66709C5.5281 5.62993 5.75259 5.46843 5.87017 5.23465L7.2853 2.421Z",
    fill: "#FFB600"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5763_49057",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 7,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 7,
    height: 14,
    fill: "#FFB600"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5763_49057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18521 2.421C7.48064 1.83361 8.31917 1.83361 8.6146 2.421L10.0297 5.23465C10.1473 5.46843 10.3718 5.62993 10.6308 5.66709L13.7717 6.11764C14.4323 6.2124 14.6933 7.02669 14.2109 7.48782L11.9587 9.64067C11.7657 9.82513 11.6775 10.0937 11.7234 10.3567L12.2574 13.4121C12.3713 14.0636 11.6902 14.564 11.1024 14.2607L8.26681 12.7972C8.03663 12.6783 7.76317 12.6783 7.53299 12.7972L4.69738 14.2607C4.10961 14.564 3.42854 14.0636 3.54241 13.4121L4.07636 10.3567C4.12232 10.0937 4.03407 9.82513 3.8411 9.64067L1.58895 7.48782C1.10654 7.02669 1.36755 6.2124 2.02814 6.11764L5.16897 5.66709C5.428 5.62993 5.65249 5.46843 5.77007 5.23465L7.18521 2.421Z",
    fill: "#FFB600"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d1121bb8658f90aa87e73efdceaf8480.svg";
export { ForwardRef as ReactComponent };